/* src/courses/reducers.js */

import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchCoursesTypes,
  fetchCoursesAdminTypes,
  searchCoursesTypes,
  SET_COURSE_PAGE,
  SET_COURSE_PAGE_COUNT,
} from './action_types';

import { ON_ERROR } from '../app_state/action_types';

import inputReducer from './components/AddCourse/reducers';

import { makeRequestReducer } from '../../config/client';

export const initialPaginationState = {
  page: 1,
  currentPageCount: 0,
  limit: 25,
};

const pagination = (state = initialPaginationState, action) => {
  switch (action.type) {
    case SET_COURSE_PAGE:
      return { ...state, page: action.payload };
    case SET_COURSE_PAGE_COUNT:
      return { ...state, currentPageCount: action.payload };
    case ON_ERROR:
    default:
      return state;
  }
};

const main = makeRequestReducer({
  types: fetchCoursesTypes,
  name: 'courses',
  mutate: (state, res) => keyBy(res, '_id'),
  append: [
    (state, action) => {
      switch (action.type) {
        case ON_ERROR:
          return { ...state, data: {} };
        default:
          return state;
      }
    },
  ],
});

const search = makeRequestReducer({
  types: searchCoursesTypes,
  name: 'searchCourses',
  initialData: [],
});

const admin = makeRequestReducer({
  types: fetchCoursesAdminTypes,
  name: 'list',
});

export default combineReducers({
  input: inputReducer,
  admin,
  main,
  search,
  pagination,
});



// WEBPACK FOOTER //
// ./src/modules/courses/reducers.js